var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { PromiseEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class LoginAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onSuccess = new PromiseEventListener();
        /** @event */
        this.onCatch = new PromiseEventListener();
    }
    /**
     * Gets the login about box properties.
     */
    getAboutBoxProps() {
        return this.state.aboutBoxProps;
    }
    /**
    * Sets the login about box properties.
    *
    * @param aboutBoxProps - The login about box properties.
    */
    setAboutBoxProps(aboutBoxProps) {
        this.setState({ aboutBoxProps });
    }
    /**
     * Gets the application name.
     */
    getApplicationName() {
        return this.state.applicationName;
    }
    /**
    * Sets the application name.
    *
    * @param applicationName - The application name.
    */
    setApplicationName(applicationName) {
        this.setState({ applicationName });
    }
    /**
     * Gets the footer expression.
     */
    getFooterExpression() {
        return this.state.footerExpression;
    }
    /**
    * Sets the footer expression.
    *
    * @param footerExpression - The footer expression.
    */
    setFooterExpression(footerExpression) {
        this.setState({ footerExpression });
    }
    /**
     * Gets the forgot password expression.
     */
    getForgotPasswordExpression() {
        return this.state.forgotPasswordExpression;
    }
    /**
    * Sets the forgot password expression.
    *
    * @param forgotPasswordExpression - The forgot password expression.
    */
    setForgotPasswordExpression(forgotPasswordExpression) {
        this.setState({ forgotPasswordExpression });
    }
    /**
     * Returns if the footer will be hidden.
     */
    getHideFooter() {
        return this.state.hideFooter;
    }
    /**
    * Sets if the footer will be hidden.
    *
    * @param hideFooter - If the footer will be hidden.
    */
    setHideFooter(hideFooter) {
        this.setState({ hideFooter });
    }
    /**
     * Gets the localized label options.
     *
     * @deprecated Use the `aboutBoxProps.localizedLabel` property.
     */
    getLocalizedLabel() {
        return this.state.aboutBoxProps.localizedLabel ?? this.state.localizedLabel;
    }
    /**
    * Sets the localized label options.
    *
    * @param localizedLabel - The localized label options.
    *
    * @deprecated Use the `aboutBoxProps.localizedLabel` property.
    */
    setLocalizedLabel(localizedLabel) {
        this.setState({
            ...this.state,
            aboutBoxProps: {
                ...this.state.aboutBoxProps,
                localizedLabel,
            },
            localizedLabel,
        });
    }
    /**
     * Gets the login expression.
     */
    getLoginExpression() {
        return this.state.loginExpression;
    }
    /**
    * Sets the login expression.
    *
    * @param loginExpression - The login expression.
    */
    setLoginExpression(loginExpression) {
        this.setState({ loginExpression });
    }
    /**
     * Gets the logo.
     */
    getLogo() {
        return this.state.logo;
    }
    /**
    * Sets the logo.
    *
    * @param logo - The logo.
    */
    setLogo(logo) {
        this.setState({ logo });
    }
    /**
     * Gets the notification.
     */
    getNotification() {
        return this.state.notification;
    }
    /**
    * Sets the notification.
    *
    * @param notification - the notification.
    */
    setNotification(notification) {
        return this.setState({ notification });
    }
    /**
     * Removes the notification.
     */
    removeNotification() {
        return this.setState({ notification: undefined });
    }
    /**
     * Gets the password expression.
     */
    getPasswordExpression() {
        return this.state.passwordExpression;
    }
    /**
    * Sets the password expression.
    *
    * @param passwordExpression - the password expression.
    */
    setPasswordExpression(passwordExpression) {
        this.setState({ passwordExpression });
    }
    /**
     * Gets the username expression.
     */
    getUsernameExpression() {
        return this.state.usernameExpression;
    }
    /**
    * Sets the username expression.
    *
    * @param usernameExpression - the username expression.
    */
    setUsernameExpression(usernameExpression) {
        this.setState({ usernameExpression });
    }
    /**
     * Gets the version expression.
     */
    getVersionExpression() {
        return this.state.versionExpression;
    }
    /**
    * Sets the version expression.
    *
    * @param versionExpression - the version expression.
    */
    setVersionExpression(versionExpression) {
        this.setState({ versionExpression });
    }
    /**
     * Returns if the version will be hidden.
     */
    getHideVersion() {
        return this.state.hideVersion;
    }
    /**
    * Sets if the version will be hidden.
    *
    * @param hideVersion - If the version will be hidden.
    */
    setHideVersion(hideVersion) {
        this.setState({ hideVersion });
    }
    /**
     * Gets the sign in expression.
     */
    getSignInTextExpression() {
        return this.state.signInTextExpression;
    }
    /**
    * Sets the sign in expression.
    *
    * @param signInTextExpression - the sign in expression.
    */
    setSignInTextExpression(signInTextExpression) {
        this.setState({ signInTextExpression });
    }
    /**
     * Gets the sign in title expression.
     */
    getSignInTitleExpression() {
        return this.state.signInTitleExpression;
    }
    /**
    * Sets the sign in title expression.
    *
    * @param signInTitleExpression - the sign in title expression.
    */
    setSignInTitleExpression(signInTitleExpression) {
        this.setState({ signInTitleExpression });
    }
    /**
     * Gets the instructions for use expression.
     */
    getInstructionsForUseExpression() {
        return this.state.instructionsForUseExpression;
    }
    /**
    * Sets the instructions for use expression.
    *
    * @param instructionsForUseExpression - the instructions for use expression.
    */
    setInstructionsForUseExpression(instructionsForUseExpression) {
        this.setState({ instructionsForUseExpression });
    }
    /**
     * Gets the login "instructions for use" text editor properties.
     */
    getInstructionsForUseProps() {
        return this.state.instructionsForUseProps;
    }
    /**
    * Sets the login "instructions for use" properties.
    *
    * @param instructionsForUseProps - The login "instructions for use" properties.
    */
    setInstructionsForUseProps(instructionsForUseProps) {
        this.setState({ instructionsForUseProps });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], LoginAPI.prototype, "onSuccess", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], LoginAPI.prototype, "onCatch", void 0);
export { LoginAPI, };
//# sourceMappingURL=login-api.js.map